var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "58px",
    viewBox: "0 0 61 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send to your doctor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.00997875,0 C2.24304389,0 0,2.24553095 0,5.00003191 L0,44.9999681 C0,47.7614095 2.24349151,50 5.00997875,50 L53,50 L53,0 L5.00997875,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-10.0%",
    width: "126.4%",
    height: "128.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEBAPP-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-like-me-mobile01",
    transform: "translate(-263.000000, -373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send2",
    transform: "translate(267.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-shadow-z=\"1\"-copy-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0C9BED",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-doctor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2298611,22.8180081 C16.4834028,22.2854106 17.6853472,22.4563089 17.4395833,22.4213415 C17.2263889,22.390935 17.0222222,22.3349593 16.8305556,22.2547967 L8.16944444,22.2547967 C7.97777778,22.3349593 7.77361111,22.390935 7.56041667,22.4213415 C7.31736111,22.4558943 8.51659722,22.2854106 4.77013889,22.8180081 C2.03263889,23.2070732 0,25.5393902 0,28.2904878 L0,34 L25,34 L25,28.2904878 C25,25.5393902 22.9673611,23.2070732 20.2298611,22.8180081 Z",
    id: "Path",
    fill: "#47C1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C7.89791667,0 4.16666667,3.71304878 4.16666667,8.29268293 L4.2875,11.0569106 L20.7125,11.0569106 L20.8333333,8.29268293 C20.8333333,3.71304878 17.1020833,0 12.5,0 Z",
    id: "Path",
    fill: "#F3BC57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7083333,11.1453659 L20.7125,11.0569106 C19.2444444,11.0506911 18.0555556,9.86345528 18.0555556,8.40117886 L18.0555556,8.29268293 L15.6069444,8.29268293 C13.7027778,8.29268293 11.9625,7.22292683 11.1111111,5.52845528 C11.1111111,7.055 9.86736111,8.29268293 8.33333333,8.29268293 L6.94444444,8.29268293 L6.94444444,8.40117886 C6.94444444,9.86345528 5.75555556,11.0506911 4.2875,11.0569106 L4.29166667,11.1453659 C3.42013889,11.3927642 2.77777778,12.1833333 2.77777778,13.1300813 C2.77777778,14.2751626 3.71041667,15.203252 4.86111111,15.203252 L5.59930556,15.203252 C6.58958333,17.1914228 8.03125,18.9660569 9.72291667,19.9404472 L9.72222222,19.9411382 C9.72222222,20.9728862 9.09097222,21.8754065 8.16944444,22.2547967 L12.5,27.6422764 L16.8305556,22.2547967 C15.9090278,21.8754065 15.2777778,20.9728862 15.2777778,19.9411382 L15.2770833,19.9404472 C16.96875,18.9660569 18.4104167,17.1914228 19.4006944,15.203252 L20.1388889,15.203252 C21.2895833,15.203252 22.2222222,14.2751626 22.2222222,13.1300813 C22.2222222,12.1833333 21.5798611,11.3927642 20.7083333,11.1453659 Z",
    id: "Path",
    fill: "#FAD9B0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.8031931,29 C20.1217466,26.2111292 20.0535898,24.3101767 19.5987228,23.2971424 C19.1438557,22.2841081 17.6109481,21.8644388 15,22.0381344 L16.4899998,23.0031045 C18.1464354,23.0553672 18.9746532,23.6351895 18.9746532,24.7425717 C18.9746532,25.8499538 18.9746532,27.2690966 18.9746532,29 L19.8031931,29 Z",
    id: "Path-13",
    fill: "#6B44FA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F3EFF0",
    fillRule: "nonzero",
    cx: 19.5,
    cy: 29.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22.0169062 C7.98209846,21.9590482 7.34613578,22.0496955 7.09211195,22.2888479 C6.71107622,22.6475765 7.09211195,27.5144667 7.09211195,27.5144667 C7.09211195,27.5144667 5.88959568,27.269454 5.34161359,27.5144667 C4.97629219,27.6778085 4.90397668,28.8396529 5.12466706,31 L5.51724635,31 C5.51724635,29.5076303 5.51724635,28.6506334 5.51724635,28.4290093 C5.51724635,28.0965733 6.03427596,27.9850137 6.56215947,27.9850137 C6.91408181,27.9850137 7.47787677,28.0054327 8.25354434,28.0462709 L8.21064437,31 L8.70753598,31 C8.90802925,28.6763111 8.90802925,27.5144667 8.70753598,27.5144667 C8.50704271,27.5144667 8.1539381,27.5144667 7.64822216,27.5144667 L7.64822216,22.6930902 L8.41255964,22.508507 L9,22.0169062 Z",
    id: "Path-14",
    fill: "#6B44FA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    fill: "#F3EFF0",
    fillRule: "nonzero",
    cx: 8.5,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-19",
    fill: "#F3EFF0",
    fillRule: "nonzero",
    cx: 5.5,
    cy: 31.5,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDoctor);
export default __webpack_public_path__ + "static/media/sendDoctor.d2ec0af20700c0d9d389e80b8aa16b47.svg";
export { ForwardRef as ReactComponent };